export const START_LOAD_TODOS = "START_LOAD_TODOS";
export const LOAD_TODOS = "LOAD_TODOS";
export const EMPTY_TODOS = "EMPTY_TODOS";
export const LOAD_TODOS_FAILED = "LOAD_TODOS_FAILED";
export const SET_TODO_COUNT = "SET_TODO_COUNT";
export const SET_TODO_DRAWER_STATE = "SET_TODO_DRAWER_STATE";
export const START_LOAD_TODOS_SUMMARY = "START_LOAD_TODOS_SUMMARY";
export const LOAD_TODOS_SUMMARY = "LOAD_TODOS_SUMMARY";
export const EMPTY_TODOS_SUMMARY = "EMPTY_TODOS_SUMMARY";
export const LOAD_TODOS_SUMMARY_FAILED = "LOAD_TODOS_SUMMARY_FAILED";
export const LOAD_TODO_TYPE_GROUP_MAPPINGS = "LOAD_TODO_TYPE_GROUP_MAPPINGS";
export const LOAD_TODOS_FOR_URGENCY = "LOAD_TODOS_FOR_URGENCY";
export const LOAD_TODOS_FOR_GROUP = "LOAD_TODOS_FOR_GROUP";
export const LOAD_CURRENT_NAVIGATION_ITEMS = "LOAD_CURRENT_TODO_NAVIGATION_ITEMS";
export const REFRESH_CURRENT_NAVIGATION_ITEMS = "REFRESH_CURRENT_TODO_NAVIGATION_ITEMS";
export const SET_CURRENT_INDEX = "SET_CURRENT_TODO_INDEX";
export const SET_LIST_NAVIGATION = "SET_TODO_LIST_NAVIGATION";
export const SET_LAST_VIEWED_TYPE = "SET_LAST_VIEWED_TYPE";
export const SET_LAST_VIEWED_TAB = "SET_LAST_VIEWED_TAB";
